import React, { useEffect } from "react";
import Button from "../../shared/button/button";
import { IMAGE_DEFAULT_ERROR_BOUNDARY } from "@/main/services/constants";
import { getParamsToGetTranslates, getTranslateByKey } from "@/main/services/utils";
import { useTranslateHook } from "@/main/hooks/translateHook";
import LoadingComponent from "../../shared/loading/loadingComponent";
import * as S from "./styles";

function LayoutErrorApp() {
	const translatesPage = [
		"t.nah.information.refresh",
		"e.nah.information.anUnexpectedErrorOccurredPleaseTryAgainLater",
	];
	const { isLoadingTranslates, translatesLocal, getTranslates } = useTranslateHook({
		filter: {
			keysList: translatesPage,
		},
		fillTranslateLocal: true,
	});

	useEffect(() => {
		const { idCultureUser, lastSyncTranslations } = getParamsToGetTranslates();
		getTranslates({ culture: idCultureUser, lastSyncTranslations });
	}, []);

	function handleClickBackToHome(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		window.location.reload();
	}

	if (isLoadingTranslates) return <LoadingComponent />;
	const messageError = getTranslateByKey(
		"information.anUnexpectedErrorOccurredPleaseTryAgainLater",
		true,
		translatesLocal,
	);

	return (
		<S.Container>
			<S.ImageError src={IMAGE_DEFAULT_ERROR_BOUNDARY} alt={messageError} />
			<S.MessageError>{messageError}</S.MessageError>
			<Button id="id-errorScreen-btn-refresh" type="button" onClick={handleClickBackToHome}>
				{getTranslateByKey("information.refresh", false, translatesLocal)}
			</Button>
		</S.Container>
	);
}

export default LayoutErrorApp;
